import { ReflagProvider } from '@reflag/react-sdk';
import { Typography, Box, styled } from '@mui/material';
import { AdminUserRealm } from 'further-types/admin-user';
import EisRoutes from './RouteSetup/EisRoutes';
import LpRoutes from './RouteSetup/LpRoutes';
import PageLoader from 'components/PageLoader';
import useAuth from 'hooks/auth/useAuth';
import DownloadTrayContainer from 'components/DownloadTrayContainer';
import VehicleSelectionGate from 'layouts/OldLayout/VehicleSelectionGate';
import Button from 'components/Button';
import Row from 'components/Layout/Row';

const Logo = styled('img')({
  height: '24px',
});

const Routes: React.FC = () => {
  const { isLoading, realm, actionableError, loginWithRedirect, logout, user } =
    useAuth();

  const reflagPublishableKey = process.env.REACT_APP_REFLAG_KEY!;
  const reflagContext = {
    company:
      realm === AdminUserRealm.Super
        ? { id: 'Further', realm: AdminUserRealm.Super, name: 'Further' }
        : {
            id: user.data?.firm?._id,
            realm,
            name: user.data?.firm?.firmName,
          },
    user: {
      id: user.data?._id,
      email: user.data?.email,
      name: `${user.data?.firstName} ${user.data?.lastName}`,
    },
  };

  if (actionableError) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        gap={6}
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <Logo src="images/logo.png" alt="Further" />
        <Typography>{actionableError}</Typography>
        <Row spacing="sm">
          <Button
            variant="outlined"
            onClick={() => {
              loginWithRedirect({
                appState: {
                  returnTo: '/',
                },
              });
            }}
          >
            Retry
          </Button>
          <Button variant="outlined" onClick={() => logout()}>
            Logout
          </Button>
        </Row>
      </Box>
    );
  }

  if (isLoading) {
    return <PageLoader />;
  }

  if (realm === AdminUserRealm.Lp) {
    return (
      <ReflagProvider
        publishableKey={reflagPublishableKey}
        context={reflagContext}
      >
        <VehicleSelectionGate>
          <LpRoutes />
        </VehicleSelectionGate>
      </ReflagProvider>
    );
  }

  if (realm === AdminUserRealm.Eis || realm === AdminUserRealm.Super) {
    return (
      <ReflagProvider
        publishableKey={reflagPublishableKey}
        context={reflagContext}
      >
        <EisRoutes />
        <DownloadTrayContainer />
      </ReflagProvider>
    );
  }
  return null;
};

export default Routes;
